import { NvmAppType } from '~/graphql/types';

import { AppType } from '~/graphql/types';
import { assertNever } from '~/util/assertNever';

/**
 *
 * @param {AppType} appType - AppType
 * keywords: brainbayapp, requiresnvmauth
 */
const getNvmAppType = (appType: AppType): NvmAppType => {
  switch (appType) {
    case AppType.BbWaardecheck:
      return NvmAppType.BbWaardecheck;
    case AppType.Biedwijzer:
      return NvmAppType.Biedwijzer;
    default:
      return assertNever(appType as never);
  }
};

export default getNvmAppType;
